export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7919.18061d18.jpg";